import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/sharp-solid-svg-icons/faArrowLeft';

import style from '../style.module.less';

export const ExitAdvancedSearchIcon = () => <FontAwesomeIcon className={style['advanced-search-exit-arrow']} icon={faArrowLeft} />;
